import { Stack } from "@mui/material";
import ForgotPasswordForm from "../components/app/utils/fogot-password-form/ForgotPasswordForm";

export default function forgotPasswordPage(props) {
   return (
      <>
         <ForgotPasswordForm />
      </>
   );
}
